const GlobalAlerts = require('global_alerts');
const Lang = require('lang');

/**
 * Faz a funcao de paginacao do laravel virar um scroll infinito,
 * utilizando a propria paginacao que o laravel fornece como fonte
 * para as requisições
 *
 * Elemento com o scroll deve ter o atributo data-infinite-scroll
 *
 * Elemento onde vai ser adicionado o conteudo retornado do ajax
 * deve ter o atributo data-infinite-scroll-content
 *
 * Element que vai servir de loading deve ter o atributo data-infinite-scroll-loading
 */
function MakeInfiniteScrollOnEach(body = false, type = 'GET', data = null) {
  const $infiniteScroll = $('[data-infinite-scroll]');

  if (!$infiniteScroll.length) {
    return;
  }

  $infiniteScroll.each((i, el) => {
    MakeInfiniteScroll(el, body, type, data);
  });
}

function MakeInfiniteScroll(element, body = false, type = 'GET', data = null) {
  let inProgress = false;

  const $el = $(element);
  const $container = $el.find('[data-infinite-scroll-content]');
  const $loading = $el.find('[data-infinite-scroll-loading]');

  let $nextPageEl = $el.find('.pagination li.active + li a');
  let nextPage = $nextPageEl.length ? $nextPageEl.last().href : null;
  // em alguns casos o last não possui href e retorna undefined,
  // então deve buscar o primeiro elemento
  if (nextPage === undefined) {
    nextPage = $nextPageEl[0].href;
  }

  if (data === null || (data && data.type !== 'restrictiveTag')) {
    $el.find('ul.pagination').last().remove();
  }
  $loading.hide();

  const onScroll = () => {
    if (inProgress || nextPage === null) {
      return;
    }

    if (
      !body
        ? $el.scrollTop() + $el.innerHeight() >= $el[0].scrollHeight
        : $(window).scrollTop() + 1.5 * parseInt($(window).height()) >= parseInt($(document).height())
    ) {
      if (data === null || data.type !== 'restrictiveTag') {
        // Mostra o loading
        $loading.show();
        // O loading fica localizado abaixo do ultimo item do scroll, e ao mostrar
        // ele na tela o scroll aumenta para baixo ele acaba não aparecendo no
        // limite da altura da div, então após mostrar o loading nós forçamos
        // o scroll pro fim do elemento
        $el[0].scrollTo(0, $el[0].scrollHeight);

        inProgress = true;
        if (data && data.type) {
          nextPage = nextPage.replace(/(?:\&)type(.*?&)/g, '');
          delete data.type;
        }

        $.ajax({
          'url': nextPage,
          'data': data,
          'type': type
        })
          .always(() => {
            $loading.hide();
            inProgress = false;
          })
          .done(data => {
            const $data = $('<div>' + data + '</div>');
            $nextPageEl = $data.find('.pagination li.active + li a');
            nextPage = $nextPageEl.length ? $nextPageEl[0].href : null;

            $data.find('ul.pagination').remove();

            $container.append($data.html());
          })
          .fail((response) => {
            GlobalAlerts.createAndShow({
              type: 'danger',
              title: Lang.get('js/common/phrases.ops'),
              message: Lang.get('js/common/phrases.unexpected_error'),
            });
          });
      }
    }
  };
  if (!body) {
    $el.on('scroll', onScroll);
    $el.on('touchmove', onScroll);
  } else {
    $(document).on('scroll', onScroll);
    $(document).on('touchmove', onScroll);
  }
}

module.exports = {
  init: MakeInfiniteScrollOnEach
}
